/**
 * Feature flag for the "CSAF" file browser feature.
 */
export const FEATURE_FLAG_CSAF = 'CSAF' as const;
